import React, { useState } from "react";
import "./MainContainer.css";
import rapperImageLoader from "../../utils/helperFunctions.js";

// import data:
import rapperData from "../../utils/complex-brackets-rappers.json";
import Start from "../Start/Start";
import Bracket from "../Bracket/Bracket";
import Share from "../Share/Share";


function MainContainer(props) {
  const [display, setDisplay] = useState("start");
  const [gameData, setGameData] = useState([]);
  const [animationContainer, setAnimationContainer] = useState(false);
  const [winner, setWinner] = useState("");
  const [gameDataWinners, setGameDataWinners] = useState("");
  const displayNone = {
    display: 'none'
  };
  // currentView() decides which view to show:
  let currentView = () => {
    let showView = "";
    switch (display) {
      case "play":
        showView = <Bracket selectGameMode={selectGameMode} gameData={gameData} setGameWinner={setGameWinner} handleGameDataWinners={handleGameDataWinners} />;
        break;
      case "share":
        showView = <Share selectGameMode={selectGameMode} gameData={gameDataWinners} winner={winner} />;
        break;
      default:
        showView = <Start displayAnimationContainer={displayAnimationContainer} selectGameMode={selectGameMode} gameData={rapperData} />;
        break;
    }
    return showView;
  };

  const renderCachedImages = ()=>{
    const rapperImages = [];
    let i = 0;

    rapperData.forEach(rapper=>{
      let imgSrc = rapperImageLoader(rapper.pic);
      rapperImages.push(<img src={imgSrc} key={i++} alt="" />);
    });

    return rapperImages;
  };

  // Randomization function, fills array with 16 random integers:
  // const randomizeGameData = (data) => {
  //   let result = [];
  //   let randomIndexes = [];
  //   // Randomize data
  //   for (let i = 0; i < 30; i++) {
  //     let randomIndex = Math.floor(Math.random() * data.length);
  //     if (randomIndexes.indexOf(randomIndex) === -1) {
  //       result.push(data[randomIndex]);
  //       randomIndexes.push(randomIndex);
  //       if (result.length >= 16) {
  //         break;
  //       }
  //     }
  //   }
  //   console.log("=> Randomize Game Data results: %o ", result);
  //   return result;
  // };

  let setGameWinner = (thirtyOne) => {
    setWinner(thirtyOne);
    if (!window.winnerAlreadyTracked) {
      window.trackEvent(`Winner is ${thirtyOne.name}`);
      window.winnerAlreadyTracked = true;
    }
  }

  let handleGameDataWinners = (data) => {
    setGameDataWinners(data)
  }

  //Randomization function, fills array with 16 random integers:
  let randomizeGameData = (data) => {
    // if no data was passed just use all rappers data
    // data = data || rapperData;
    let d = data;
    if (d.length === 0) {
      d = rapperData;
    }

    let result = [];
    //randomization logic
    var randInt = [];
    while (randInt.length < 16) {
      var r = Math.floor(Math.random() * d.length);
      if (randInt.indexOf(r) === -1) randInt.push(r);
    }
    for (var i = 0; i < randInt.length; i++) {
      result.push(d[randInt[i]]);
    }
    return result;
  };

  //create gameData array
  const updateGameDataState = (data) => {
    let randomizedData = randomizeGameData(data);
    let newGameData = [];
    // Distribute the data to each side positions
    for (let i = 1; i <= 31; i++) {
      if (i <= 8) {
        newGameData[i] = randomizedData[i - 1];
      } else if (i <= 22) {
        newGameData[i] = undefined;
      } else if (i < 31) {
        newGameData[i] = randomizedData[i - 15];
      } else if (i === 31) {
        newGameData[i] = undefined;
      }
    }
    // Set game data state
    // console.log("=> Setting Game Data state: %o ", newGameData);
    setGameData(newGameData);
  }

  let gameModeFilters = {
    "top100": function (obj) {
      return true;
    },
    "west": function (obj) {
      return obj.region.match(/west coast/gi) !== null;
    },
    "east": function (obj) {
      return obj.region.match(/east coast/gi) !== null;
    },
    "dirtySouth": function (obj) {
      return obj.region.match(/dirty south/gi) !== null;
    },
    "2010": function (obj) {
      return obj.decade.match(/2010/gi) !== null;
    }
  }

  /**
   * Helps selecting the game mode and data filtering
   * @param {string} mode - can be "start", "play", "loading"
   * @param {string} filter - options: "top100", "west", "east", "2010"
   */

  let selectGameMode = async (mode, filter = '') => {
    let gameData = [];
    let filterBy = gameModeFilters[filter] || null;
    // Filter Data
    if (filterBy) {
      gameData = rapperData.filter(filterBy);
      if (gameData.length < 16) {
        console.log('Theres not enough rappers within the database to fill the bracket.');
      }
    }
    updateGameDataState(gameData);
    setDisplay(mode);
    return gameData;
  };

  let displayAnimationContainer = (visible = false) => {
    setAnimationContainer(visible);
  };

  return <div id="MainContainer" className="noselect">
    <div className={animationContainer ? 'animation_container show' : 'animation_container'}>
      <div className="loading-panel top">
        <div className="loader show">
          <div className="start_logo_container ">
            <div className="start_logo_text animated flash infinite">BUILDING BRACKET...</div>
            <div className="start_logo animated bounceInDown"></div>
          </div>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 1080" width="100%" height="100%" className="lines_animation">
            <g id="center">
              <path className="st0 miRyqrRa_0" d="M956 539H714M958 539h244"></path>
            </g>
            <g id="verticals1">
              <path className="st0 miRyqrRa_1" d="M1199 536V253M1199 542v283M717 536V253M717 542v283"></path>
            </g>
            <g id="horizontals1">
              <path className="st0 miRyqrRa_2" d="M1196 250h236M1196 828h239M720 250H482M720 828H482"></path>
            </g>
            <g id="verticals2">
              <path className="st0 miRyqrRa_3" d="M1429 247V104M1429 253v144M1432 825V688M1432 831v138M485 247V111M485 253v139M485 825V689M485 831v139"></path>
            </g>
            <g id="horizontals2">
              <path className="st0 miRyqrRa_4" d="M1429 107h239M1429 394h240M1429 685h239M1429 972h239M488 108H249M488 395H248M488 686H249M488 973H249"></path>
            </g>
            <g id="verticals3">
              <path className="st0 miRyqrRa_5" d="M1665 104V38M1665 110v66M1666 391v-63M1666 397v69M1665 682v-67M1665 688v65M252 105V38M252 111v65M251 392v-64M251 398v68M252 683v-68M252 689v64M252 970v-66M252 976v66M1665 969v-65M1665 975v67"></path>
            </g>
            <g id="horizontals3">
              <path className="st0 miRyqrRa_6" d="M1662 35h230M1662 179h230M1663 325h230M1663 469h230M1662 612h230M1662 756h230M1662 901h230M1662 1045h230M255 35H25M255 179H25M254 325H24M254 469H24M255 612H25M255 756H25M255 901H25M255 1045H25"></path>
            </g>
          </svg>
        </div>
      </div>
    </div>
    {currentView()}
    <div style={displayNone} className="cache">
      {renderCachedImages()}
    </div>
  </div>;
}

export default MainContainer;
